import React, { useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { INACTIVE_TIME } from '../../config';

const InactivityTimer: React.FC = () => {
  const { logout } = useAuth();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(logout, INACTIVE_TIME);
  };

  useEffect(() => {
    // Set up event listeners for user activity
    // Only count explicit user interactions as activity. `mousemove` and
    // `scroll` fire on involuntary cursor jitter, mouse jigglers, and
    // programmatic scrolls (virtualized grids, dropdowns), which kept the
    // timer alive indefinitely on data-heavy pages like overview.
    const activityEvents = ['mousedown', 'keydown', 'touchstart'];

    const handleActivity = () => {
      resetTimer();
    };

    activityEvents.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    // Initial timer setup
    resetTimer();

    // Cleanup function
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      activityEvents.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [logout]);

  return null; // This component doesn't render anything
};

export default InactivityTimer;
